import Brett from "./Brett";
import SpiegelO3 from "../object3d/Spiegel";

export default class Spiegel {

    // DO NOT CHANGE
    className = "Spiegel";
    
    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    parent: Object;
    brett: Brett;

    constructor(parent, brett) {
        this.parent = parent;
        this.brett = brett;
    }

    get schrank() {
        return this.parent.schrank;
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

    compile() {
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new SpiegelO3(this, this.brett);
            this.parent.child3dContainer.add(o3);
            return o3;
        });
    }

    iterate(iterator) {
        iterator(this);
        this.brett && iterator(this.brett);
    }

}
